import createLazyComponent from '../LazyComponent';

const ContactUs = createLazyComponent(() => import('./ContactUsPage'));

export default ContactUs;
